<!-- компонент View: просмотр объекта -->
<template>
	<div v-if="this.$store.state.is_auth">

		<template v-if="!form_ErrorMessage">

			<!-- блок с локальным сообщением об ошибке -->
			<transition name="fadeControl">
				<div v-show="localErrorMessage !== ''" class="alert alert-danger margin-20-0" role="alert">
					<span @click="localErrorMessage = ''" class="close" aria-label="close" :title="'main/close' | ftc">×</span>
					<span style="padding:0;margin:0;" v-withSafeTags="localeFtc(localErrorMessage)"></span>
				</div>
			</transition>
			<!-- ===================================== -->

			<!-- Заголовок -->
			<h4 class="w5-view-header">{{ viewData.title | ftc }}</h4>
			<!-- ===================================== -->

			<!-- поля -->
			<div v-if="Keys.length" v-for="row in Keys" :key="row" class="w5-form-row">
				<viewComponent
					v-for="(field, idx) in sortDATA[row]" :key="row + '_' + idx"
					:data="viewData"
					:rowCount="sortDATA[row].length"
					:y="row"
					:x="idx"
					:field="field"
					:crud="crud"
					:realCrudName="realCrudName"
					:firstElement="sortDATA && sortDATA['1'] && sortDATA['1'][0] ? sortDATA['1'][0] : null"
					:objectId="id"
					@needRefresh="needRefresh"
					@errorFilter="errorFilter"
				/>
			</div>
			<!-- ===================================== -->

			<!-- логи -->
			<div v-if="viewData && 'logs' in viewData && viewData['logs'] && Array.isArray(viewData['logs']) && viewData['logs'].length" class="w5-form-row">
			<div class="w5-view-field" style="width: 100%">
				<h4 class="w5-view-header">{{ 'logs/title' | ftc }}</h4>
				<table class="w5-view-field-table w5-view-field-table-logs">
					<thead>						
						<tr>
							<th style="width: 120px">{{ 'main/created' | ftc }}</th>
							<th>{{ 'operation/comment' | ftc }}</th>
							<th v-if="$store.state.user_type === 'admin'">{{ 'main/data' | ftc }}</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(log, idx) in viewData['logs']" :key="'tr-' + idx">
							<td align="center" :aria-label="'main/created' | ftc">
								<span class="w5-table-cell">
									{{ log.log_date && log.log_date.value ? formater_StrDateFormat(log.log_date.value) : '' }}
								</span>
							</td>
							<td :aria-label="'operation/comment' | ftc">
								<span class="w5-table-cell">
									{{ log.log_comment && log.log_comment.value ? log.log_comment.value : '' | ftc }}
								</span>
							</td>
							<td v-if="$store.state.user_type === 'admin'" :aria-label="'main/data' | ftc">
								<span class="w5-table-cell"><pre v-if="log.log_data && log.log_data.value && String(log.log_data.value).trim() !== ''">{{ log.log_data.value }}</pre></span>
							</td>
						</tr>					
					</tbody>
				</table>
			</div>
			</div>
			<!-- ===================================== -->

			<div class="w5-field">
				<button type="button" class="btn btn-default pull-right" :class="{ hidden: form_Loading }" @click.stop="backButton">{{ 'main/back' | ftc }}</button>
				<span class="clearfix"></span>
			</div>

		</template>

		<errorAlert v-else :message="form_ErrorMessage" />

	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Vue from 'vue'
import viewComponent from '@/components/elements/view'
import { EventBus } from '@/bus.js'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование компонента
	//=========================================================================
	name: 'ViewComponent',
	//=========================================================================
	//
	//=========================================================================
	data() {
		return {
			// наименование CRUD-объекта (например: 'bonus')
			crud: null,

			// ID наблюдаемого объекта
			id: null,

			// локальное сообщение об ошибке
			localErrorMessage: '',

			// отсортированные данные
			sortDATA: {},

			// ключи полей
			Keys: false,

			// кешированные данные для просмотра
			viewData: {}
		}
	},
	//=========================================================================
	//  вычисляемые неизменяемые переменные
	//=========================================================================
	computed: {
		// тип пользователя
		UserType() {
			return this.$store.state.user_type
		},
		// текущий адрес сервера приложения
		AppServerUrl() {
			return Vue.AppServerUrl
		},
		// Настоящее название CRUD
		realCrudName() {
			return this.__realCrudName(this.crud)
		}
	},
	//=========================================================================
	// функция, которыя будет вызвана после создания компонента,
	// но перед монтированием в дом
	//=========================================================================
	created() {
		// если не авторизован - редирект на страницу логина
		if (!this.$store.state.is_auth)
		{
			// сброс аутентификации
			this.$store.commit('dropAuth')
			// запоминаем URL, что бы к нему вернуться
			this.$store.commit('setReturnURL', this.$route.path)
			// остановим Push-систему
			this.$store.commit('pushStop')
			// делаем редирект
			return this.$router.push('/login')
		}

		// инициализация начальных данных по URL
		this.initData(this.$route.path)

		// теперь можно запросить данные
		if (this.crud) this.requestViewData()
	},
	//=========================================================================
	// после того как компонент смонтирован
	//=========================================================================
	mounted() {
		// подписка на Push-сообщения
		EventBus.$on('w5-push', this.pushMessageHandler)
	},
	//=========================================================================
	// перед уничтожением компонента
	//=========================================================================
	beforeDestroy() {
		// отписка от Push-сообщений
		EventBus.$off('w5-push', this.pushMessageHandler)
	},
	//=========================================================================
	// наблюдаем переходы между CRUD внутри одного и того же компонента
	//=========================================================================
	watch: {
		'$route': function(to, from) {
			// инициируем основные данные, в частности и this.crud
			this.initData(to.path)

			// теперь можно запросить данные
			if (this.crud) this.requestViewData()
		}
	},
	//=========================================================================
	// локальные методы компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// инициализация начальных данных
		//---------------------------------------------------------------------
		initData(path) {
			// обнуляем основные значения
			this.crud = null
			this.id = null
			this.sortDATA = {}
			this.Keys = false
			this.localErrorMessage = ''

			// парсим входящий URL
			let _urlParts = path
				.substr(path.charAt(0) === '/' ? 1 : 0)
				.split('/')
			// должны быть минимум три части
			if (_urlParts.length < 3 ||
				!_urlParts[0] || !_urlParts[0].length ||
				!_urlParts[1] || !_urlParts[1].length ||
				_urlParts[2] === null || _urlParts[2] === undefined || _urlParts[2] === '')
			{
				this.localErrorMessage = this.localeFtc('main/unknown_page')
				return
			}
			// если вторая часть это не "view"
			if (_urlParts[1] !== 'view')
			{
				this.localErrorMessage = this.localeFtc('main/unknown_page')
				return
			}

			// получим наименование CRUD
			this.crud = _urlParts[0]

			// получим ID объекта, мы не приводим к INT, так как бывают ID строковые
			this.id = _urlParts[2]
		},
		//---------------------------------------------------------------------
		// запрос данных для просмотра
		//---------------------------------------------------------------------
		requestViewData() {
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// готовим URL
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			let _url = '/'
			if (this.crud === 'planarchive') _url += 'plan'
			else if (this.crud === 'iso' || this.crud === 'additional-services' ||
				this.crud === 'backups' || this.crud === 'certificate' ||
				this.crud === 'dns' || this.crud === 'domains' || this.crud === 'disks') _url += 'service'
			else _url += this.crud

			// проверка доступа
			if (!this.isAccess(_url + '/view'))
			{
				this.localErrorMessage = 'main/user_forbidden ' + _url.replace('/', '') + '/title'
				return
			}

			// команда - по умолчанию
			_url += '/view/'

			// ID объекта
			if (this.id) _url += this.id

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// производим запрос
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.forms_Get(_url, false,
				// успешно получили данные
				(data) => {
					// проверим данные
					if (!data || data['status'] !== 'ok' || data[this.realCrudName] === undefined || data[this.realCrudName] === null)
					{
						// ошибка - некорректные данные
						this.form_ErrorMessage = this.localeFtc('error/api_incorrect')
					}
					else
					{
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// данные пришли - корректные
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// сортировка
						this.sortDATA = this._order()
						// ключи полей
						this.Keys = Object.keys(this.sortDATA).sort(function(a, b) {
							return a - b
						})
						// свежие данные полей
						this.viewData = this.form_GetData
					}
				}
			)

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		},
		//---------------------------------------------------------------------
		// кнопка "назад"
		//---------------------------------------------------------------------
		backButton() {
			this.$router.go(-1)
		},
		//---------------------------------------------------------------------
		// сортирует данные согласно порядку
		//---------------------------------------------------------------------
		_order() {
			let obj
			let __obj
			let ____obj
			let tmp
			let order
			let isLink = 0
			let nm = ''
			let sortDATA = {}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// бежим по всем данным
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			for (let idx in this.form_GetData) if (this.form_GetData.hasOwnProperty(idx))
			{
				// текущий объект
				obj = this.form_GetData[idx]

				// логи рисуем отдельно
				if (idx === 'logs' && this.crud !== 'logs') continue
				// поле "data" в услугах игнорируем в просмотре
				if (idx === 'data' && this.crud === 'service') continue

				//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
				// рассматриваем только объекты
				//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
				if (obj && typeof obj === 'object')
				{
					// если уже есть порядок
					if ('order' in obj && obj['type'] !== 'hidden')
					{
						// получим индекс
						tmp = parseInt(obj['order'])
						order = isNaN(tmp) ? 0 : tmp

						// запомним его
						if (!sortDATA[order])
						{
							sortDATA[order] = []
							sortDATA[order].push(idx)
						}
						else sortDATA[order].push(idx)
					}
					// порядка еще нет - опускаемся на уровень ниже
					else
					{
						// это ссылка?
						isLink = 0
						nm = ''

						for (let i in obj) if (obj.hasOwnProperty(i))
							if (/_name$/i.test(i) || /_id$/i.test(i) || /_login$/i.test(i))
							{
								nm = i.match(/(.*?)_name$/)
								if (nm === null)
								{
									nm = i.match(/(.*?)_id$/)
									if (nm === null)
									{
										nm = i.match(/(.*?)_login$/)
										if (nm == null)
										{
											if (this.$store.state.isDebug) window.DEBUG.error('не найдено поле')
										}
										else nm = nm[1]
									}
									else nm = nm[1]
								}
								else nm = nm[1]

								isLink++
							}

						// если встретили два поля - значит ссылка
						if (isLink === 2 && idx !== this.realCrudName) isLink = true
						else isLink = false

						// если это ссылка
						if (isLink)
						{
							// получим индекс
							tmp = parseInt(obj[nm + '_id']['order'])
							order = isNaN(tmp) ? 0 : tmp

							// запомним его
							if (!sortDATA[order])
							{
								sortDATA[order] = []
								sortDATA[order].push(idx)
							}
							else sortDATA[order].push(idx)
						}
						// это не ссылка - просто собираем все объекты
						else
						{
							// если это массив - это один элемент
							if (Array.isArray(obj)) {
								if (obj.length) {
									// получим индекс из первого элемента
									__obj = obj[0]
									if (__obj && typeof __obj === 'object') {
										for (let i in __obj) if (__obj.hasOwnProperty(i)) {
											____obj = __obj[i]

											if (____obj && typeof ____obj === 'object' && 'order' in ____obj) {
												tmp = parseInt(____obj['order'])
												order = isNaN(tmp) ? 0 : tmp

												// запомним его
												if (!sortDATA[order])
												{
													sortDATA[order] = []
													sortDATA[order].push(idx)
												}
												else sortDATA[order].push(idx)

												break
											}
										}
									}
								}

								// на этом тут все
								continue
							}

							for (let i in obj) if (obj.hasOwnProperty(i))
							{
								// текущий объект
								__obj = obj[i]

								// рассматриваем только объекты
								if (__obj && typeof __obj === 'object' &&
									'order' in __obj &&
									'title' in __obj &&
									'value' in __obj && __obj['value'] !== null && __obj['value'] !== undefined &&
									'type' in __obj && __obj['type'] !== 'hidden')
								{
									// получим индекс
									tmp = parseInt(__obj['order'])
									order = isNaN(tmp) ? 0 : tmp

									// запомним его
									if (!sortDATA[order])
									{
										sortDATA[order] = []
										sortDATA[order].push(i)
									}
									else sortDATA[order].push(i)
								}
								else
								{
									// права для ролей
									if (idx === 'role' && i === 'permissions') sortDATA[9999] = [i]
									// данные услуги в поле service_data
									else if (idx === 'service' && i === 'service_data' && this.$store.state.user_type === 'admin')
									{
										// получим индекс
										tmp = parseInt(__obj['order'])
										order = isNaN(tmp) ? 0 : tmp

										// запомним его
										if (!sortDATA[order])
										{
											sortDATA[order] = []
											sortDATA[order].push(i)
										}
										else sortDATA[order].push(i)
									}
									// это объект, содержащий еще объекты
									else
									{
										// пробежимся по всем свойствам
										for (let w in __obj) if (__obj.hasOwnProperty(w))
										{
											// текущий объект
											____obj = __obj[w]

											// рассматриваем только объекты
											if (____obj && typeof ____obj === 'object' &&
												'order' in ____obj &&
												'title' in ____obj &&
												'value' in ____obj && ____obj['value'] !== null && ____obj['value'] !== undefined &&
												'type' in ____obj && ____obj['type'] !== 'hidden')
											{
												// получим индекс
												tmp = parseInt(____obj['order'])
												order = isNaN(tmp) ? 0 : tmp

												// запомним его
												if (!sortDATA[order])
												{
													sortDATA[order] = []
													sortDATA[order].push(w)
												}
												else sortDATA[order].push(w)
											}
										}
									}
								}
							}
						}
					}
				}

				//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// упорядочивания для частных случаев
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (this.crud === 'user' || this.crud === 'admin')
			{
				if ('1' in sortDATA)
				{
					let arr = sortDATA['1']
					let newArr = []

					// нужно убедится что именно аватар будет на первом месте
					// поэтому сначала добавим аватар
					for (let i = 0; i < arr.length; i++)
						if (arr[i].indexOf('avatar_path') !== -1)
						{
							newArr.push(arr[i])
							break
						}

					// затем остальные поля
					for (let i = 0; i < arr.length; i++)
						if (arr[i].indexOf('avatar_path') === -1)
							newArr.push(arr[i])

					sortDATA['1'] = newArr
				}
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (this.crud === 'template' || this.crud === 'payment' || this.crud === 'plangroup')
			{
				if ('1' in sortDATA)
				{
					let arr = sortDATA['1']
					let newArr = []

					// нужно убедится что именно аватар будет на первом месте
					// поэтому сначала добавим аватар
					for (let i = 0; i < arr.length; i++)
						if (arr[i].indexOf('image_path') !== -1)
						{
							newArr.push(arr[i])
							break
						}

					// затем остальные поля
					for (let i = 0; i < arr.length; i++)
						if (arr[i].indexOf('image_path') === -1)
							newArr.push(arr[i])

					sortDATA['1'] = newArr
				}
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (this.crud === 'paymentsaved')
			{
				if ('1' in sortDATA)
				{
					let arr = sortDATA['1']
					let newArr = []

					// нужно убедится что именно аватар будет на первом месте
					// поэтому сначала добавим аватар
					for (let i = 0; i < arr.length; i++)
						if (arr[i].indexOf('saved_image') !== -1)
						{
							newArr.push(arr[i])
							break
						}

					// затем остальные поля
					for (let i = 0; i < arr.length; i++)
						if (arr[i].indexOf('saved_image') === -1)
							newArr.push(arr[i])

					sortDATA['1'] = newArr
				}
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// возвращаем результат
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			return sortDATA
		},
		//---------------------------------------------------------------------
		// требуется рефреш данных
		//---------------------------------------------------------------------
		needRefresh() {
			this.requestViewData()
		},
		//---------------------------------------------------------------------
		// вывод ошибки
		//---------------------------------------------------------------------
		errorFilter(msg) {
			this.localErrorMessage = msg
		},
		//---------------------------------------------------------------------
		// обработчики Push-сообщений
		//---------------------------------------------------------------------
		pushMessageHandler(msg) {
			// проверка - не задано само сообщение
			if (!msg) return

			// разобъем сообщение на части
			let _parts = msg.split(' ')

			// проверка корректности
			if (!_parts || _parts.length < 3) return

			// сообщение нужно обработать только если совпадает CRUD
			if (_parts[1] !== this.getRealCrud(this.crud)) return

			// получим ID
			let _id = _parts[2]
			// если не задан ID - ничего не делаем
			if (!_id) return

			// если ID не совпадает
			if (String(_id) !== String(this.id)) return

			// обновляем данные, пришедшие с сервера
			// данные внутри компонента "viewComponent" автоматически
			// обновятся по наблюдателю (watch)
			this.requestViewData()
		}

		//---------------------------------------------------------------------
	},
	//=========================================================================
	// компоненты
	//=========================================================================
	components: {
		viewComponent
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.w5-view-header	{
	margin: 20px 0 10px 0;
}

table.w5-view-field-table-logs pre {
	white-space: pre-wrap;
    margin: 0;
    overflow: auto;
    background-color: #fff;
    border: none;
    padding: 3px;
    font-size: 11px;
}

@media screen and (max-width: 767px) {
	table.w5-view-field-table-logs thead {
		display: none;
	}	
	table.w5-view-field-table-logs tr:first-of-type {		
		border-top: 3px solid #ddd;
	}
	table.w5-view-field-table-logs tr {		
		border-bottom: 3px solid #ddd;
		display: block;
		font-size: 13px;
	}
	table.w5-view-field-table-logs td {
		border-bottom: 1px solid #ddd;
		display: block;
		text-align: right;
		font-size: 12px;
		min-height: 45px;
	}
	table.w5-view-field-table-logs td:before {
		font-weight: bold;
		content: attr(aria-label);
		float: left;
		width: 32%;
		text-align: left;
		font-size: 11px;
	}

	table.w5-view-field-table-logs .w5-table-cell {
		display: inline-block;
		width: 65%;
		text-align: left;
		white-space: normal;
	}
}

</style>



// WEBPACK FOOTER //
// View.vue?287c431c